import { useState } from "react";
import "./CreateUser.css";
import CustomButton from "../../ui/button/Button";
import classNames from "classnames";
import SideMenu from "../../features/sideMenu/SideMenu";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import { useNavigate } from "react-router-dom";
import { createClient } from "../functions/Projects";
import { itemsProjects } from "../../constants/projects";

const CreateClient = ({ API_URL }) => {
  const initialPayload = {
    razonSocial: "",
    alias: "",
    comentario: null, // El comentario siempre será null
  };

  const [payload, setPayload] = useState({
    ...initialPayload,
  });

  const navigate = useNavigate();
  const showDialog = useConfirmDialog();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({
      ...prev,
      [name]: value || null,
    }));
  };

  const handleSave = async () => {
    const formattedPayload = {
      ...payload,
      id: null, // No se envía el id porque es un nuevo cliente
    };

    try {
      await createClient(API_URL, formattedPayload);
      showDialog({
        html: "Cliente creado exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
        onConfirm: () => {
          // Redirigir a la página anterior después de crear
          navigate(-1);
        },
      });
    } catch (error) {
      showDialog({
        html: `Error al crear el cliente:<br>${error.message}`,
        icon: "error",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
    }
  };

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ width: "12rem" }}>
        <SideMenu items={itemsProjects} />
      </div>
      <div className="createUser">
        <div className="form-container">
          <form>
            {/* Campo razonSocial */}
            <div className="form-row">
              <label className="form-label">Nombre:</label>
              <input
                className={classNames("form-input", {
                  "error-class": !payload.razonSocial,
                })}
                type="text"
                name="razonSocial"
                value={payload.razonSocial || ""}
                onChange={handleChange}
                placeholder="Ingresa nombre"
              />
            </div>

            {/* Campo alias */}
            <div className="form-row">
              <label className="form-label">Nombre corto:</label>
              <input
                className={classNames("form-input", {
                  "error-class": !payload.alias,
                })}
                type="text"
                name="alias"
                value={payload.alias || ""}
                onChange={handleChange}
                placeholder="Ingresa nombre corto"
              />
            </div>

            <div className="button-container">
              <CustomButton
                text={"Guardar"}
                color={"#FFFFFF"}
                border={"none"}
                background={"#62C776"}
                fontStyle={"normal"}
                fontWeight={700}
                fontSize={"14px"}
                width={"75px"}
                height={"28px"}
                type={"button"}
                onClick={handleSave}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateClient;
